import React, { useEffect }  from 'react';
import WOW from "wowjs";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';


function AboutThree() {
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false, // This disables continuous scanning for new elements
        });
        wow.init();
      }, []);
  return (
    <div>
        

        {/* Start About Area  */}
        <div className="about-area about-style-three tmp-section-gap">
            <div className="container">
            <div className="row align-items-center">
                <div
                className="col-lg-6 wow zoomIn" data-wow-duration=".8s" data-wow-delay=".3s">
                <div className="about-inner">
                    <div className="thumbnail">
                    <img src="assets/images/about/about-img.jpg" alt="about" />
                    </div>
                </div>
                </div>
                <div className="col-lg-6">
                <div className="about-inner">
                    <div className="section-head pb--30  text-align-left">
                    <span className="subtitle color-gradiant">Welcome</span>
                    <h2 className="title split-collab">
                       Helping your business with <br/>smart, stress free accounting
                    </h2>
                    </div>
                    <div className="tab-section tab-style-one">
                        <Tabs>
                            <Tab eventKey="home" title="What We Offer">
                            <p className="description">
                               Highly qualified tax consultants with many years of experience in the field offer a full range of services to help you build a sound financial future. Tax advice received in time allows you to avoid many problems with the tax authorities. We will help you as efficiently as possible and in a short time.
                            </p>
                            
                            
                            </Tab>
                            <Tab eventKey="profile" title="What We Do">
                            <p className="description">
                                Accounting And Business helps individuals and businesses manage their finances. We offer personalized bookkeeping, tax preparations and financial planning services tailored to your goals. We have helped more than 200 businesses and individuals in our 5 year venture. Our client base consists of businesses from all sectors. From startups to well established businesses and small ventures to growing corporations. We have served all industries. We are proud that our business has flourished due to the personal connection we have created with our clients which leads them to refer us to anyone that needs financial services.
                            </p>
                           
                            
                            </Tab>
                            <Tab eventKey="longer-tab" title="Why Choose Us">
                            <p className="description">
                                We stand out for our commitment to excellence, integrity, and long-term partnerships. Our team of experienced professionals combines deep industry knowledge with personalized service to deliver reliable, results-driven solutions. We prioritize your goals, communicate transparently, and adapt to your evolving needs ensuring your success remains our top priority every step of the way.
                            </p>
                          
                            
                            </Tab>
                        </Tabs>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        {/* End About Area  */}


    </div>
  )
}

export default AboutThree